/**
 * Work order / hangar job `Maintenance.type` values.
 * Includes classic WO types plus AMP schedule inspection categories
 * so hangar intake can classify jobs the same way as AMP Schedules.
 */
export const AMP_INSPECTION_CATEGORY_TYPES = [
  'PHASE_INSPECTION',
  'OUT_OF_PHASE_INSPECTION',
  'LUBRICATION_INSPECTION',
  'CONDITIONAL_INSPECTION',
  'ONE_TIME_INSPECTIONS',
  'CORROSION_PREVENTION_AND_CONTROL'
];

export const CLASSIC_WORK_ORDER_TYPES = [
  'INSPECTION',
  'MAINTENANCE',
  'REPAIR',
  'SCHEDULED'
];

export const MAINTENANCE_WORK_ORDER_TYPES = [
  ...CLASSIC_WORK_ORDER_TYPES,
  ...AMP_INSPECTION_CATEGORY_TYPES
];

export const MAINTENANCE_WORK_ORDER_TYPE_LABELS = {
  INSPECTION: 'Inspection',
  MAINTENANCE: 'Maintenance',
  REPAIR: 'Repair',
  SCHEDULED: 'Scheduled',
  PHASE_INSPECTION: 'Phase Inspection',
  OUT_OF_PHASE_INSPECTION: 'Out of phase Inspection',
  LUBRICATION_INSPECTION: 'Lubrication Inspection',
  CONDITIONAL_INSPECTION: 'Conditional Inspection',
  ONE_TIME_INSPECTIONS: 'One Time Inspections',
  CORROSION_PREVENTION_AND_CONTROL: 'Corrosion Prevention and Control'
};

/** Options for New hangar job Type (AMP inspection categories first, then classic). */
export const HANGAR_JOB_TYPE_OPTIONS = [
  ...AMP_INSPECTION_CATEGORY_TYPES.map((value) => ({
    value,
    label: MAINTENANCE_WORK_ORDER_TYPE_LABELS[value]
  })),
  { value: 'INSPECTION', label: 'Inspection' },
  { value: 'MAINTENANCE', label: 'Maintenance' },
  { value: 'REPAIR', label: 'Repair' },
  { value: 'SCHEDULED', label: 'Scheduled' }
];

export const HANGAR_ENVIRONMENT_OPTIONS = [
  { value: 'LINE_INSPECTION', label: 'Line' },
  { value: 'BASE_INSPECTION', label: 'Base' },
  { value: 'ANY', label: 'Any' }
];

export function getMaintenanceWorkOrderTypeLabel(type) {
  if (type === 'REPAIR') return 'DEFECT';
  return MAINTENANCE_WORK_ORDER_TYPE_LABELS[type] || type || '—';
}
